import { createStore } from 'vuex'

export default createStore({
  state: {
    transfers: []
  },
  mutations: {
    setTransfers(state, payload){
      state.transfers = payload
    }
  },
  actions: {
    async fetchData({commit}){
      try {
        console.log("P1");
      } catch (error) {
        console.log(error)
      }
    }
  },
  modules: {
  }
})
